import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { LojaContext } from '~/context/loja';
import {
  ILoja,
  IProdutoDerivado,
  FlagsState,
  FlagsUpdater,
  initialFlags,
  MapeamentoValores,
  Select,
} from './types';
import { yupResolver } from '@hookform/resolvers/yup';
import { nanoid } from 'nanoid';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import api from '~/services/api';
import { addUpdate, MasterDetailProps } from '~/utils/masterDetail';
import { schema, schemaDerivado } from './Validations';
import {
  FormGtin,
  formGtinBlank,
  FormProduto,
  formProdutoBlank,
  FormProdutoFornecedor,
  formProdutoFornecedorBlank,
  FormProdutoFornecedorUN,
  formProdutoFornecedorUNBlank,
  FormProdutoLoja,
  formProdutoLojaBlank,
  ProdutoFornecedor,
} from './protocols';
import { ProdutoContextData } from './types/context';
import { delay } from './utils/functions';
import {
  tipoPisCofinsEntrada,
  tipoPisCofinsSaida,
} from '~/pages/Produto/constants';
import { useProdutoQueries } from './hooks/useQueriesProduto';
import { formProdutoBlankCompleto } from './constants/formBlank';

export const ProdutoContext = createContext({} as ProdutoContextData);

interface ProdutoContextProviderProps {
  children: ReactNode;
}

export function ProdutoContextProvider({
  children,
}: ProdutoContextProviderProps): JSX.Element {
  const MySwal = withReactContent(Swal);
  const { loja } = useContext(LojaContext);

  const [isUpdate, setIsUpdate] = useState(false);
  const [isShowSearch, setIsShowSearch] = useState(true);
  const [selectedLoja, setSelectedLoja] = useState(0);
  const [lojas, setLojas] = useState<number | number[]>(loja.cod_loja);
  const [formProduto, setFormProduto] = useState<FormProduto>(formProdutoBlank);

  const [selectedCodFornecedor, setSelectedCodFornecedor] = useState<
    number | undefined
  >(undefined);
  const [mainLoja, setMainLoja] = useState<ILoja>({
    des_uf: loja.des_uf,
    cod_loja: loja.cod_loja,
    des_fantasia: loja.des_fantasia,
    des_cidade: loja.des_cidade,
    cst_pis_cof_ent_aliq_zero: loja.cst_pis_cof_ent_aliq_zero,
    cst_pis_cof_ent_monof: loja.cst_pis_cof_ent_monof,
    cst_pis_cof_ent_subst: loja.cst_pis_cof_ent_subst,
    cst_pis_cof_ent_imune: loja.cst_pis_cof_ent_imune,
    cst_pis_cof_ent_susp: loja.cst_pis_cof_ent_susp,
    cst_pis_cof_entrada: loja.cst_pis_cof_entrada,
    cst_pis_cof_saida_aliq_zero: loja.cst_pis_cof_saida_aliq_zero,
    cst_pis_cof_saida_monof: loja.cst_pis_cof_saida_monof,
    cst_pis_cof_saida_subst: loja.cst_pis_cof_saida_subst,
    cst_pis_cof_saida_imune: loja.cst_pis_cof_saida_imune,
    cst_pis_cof_saida_susp: loja.cst_pis_cof_saida_susp,
    cst_pis_cof_saida: loja.cst_pis_cof_saida,
  });
  const [formProdutoLoja, setFormProdutoLoja] =
    useState<FormProdutoLoja>(formProdutoLojaBlank);

  const [tipoGtin, setTipoGtin] = React.useState(13);
  const [formGtin, setFormGtin] = useState<FormGtin>(formGtinBlank);
  // TABS
  const [tabGeral, setTabGeral] = useState<any>('icms');
  const [tab, setTab] = useState<any>('geral');

  // FORNECEDOR
  const [produtoFornecedores, setProdutoFornecedores] = useState<
    ProdutoFornecedor[]
  >([]);

  const [formProdutoFornecedor, setFormProdutoFornecedor] =
    useState<FormProdutoFornecedor>(formProdutoFornecedorBlank);
  const [formProdFornUN, setFormProdFornUN] = useState<FormProdutoFornecedorUN>(
    formProdutoFornecedorUNBlank,
  );

  // fiscal
  const [ncmIsFromTheProduct, setNcmIsFromTheProduct] = useState<boolean>(true);

  // PIS/COFINS
  const [enableModalSped, setEnableModalSped] = useState<boolean>(false);

  // IPI
  const [ipiHabilitar, setIpiHabilitar] = useState<boolean>(true);
  // EQUIVALENTES
  const [associadosPai, setAssociadosPai] = useState<any[]>([]);
  const [associadosFilho, setAssociadosFilho] = useState<any[]>([]);
  const [resetSimilar, setResetSimilar] = useState(false);
  // ====== GRADE VARIAÇÕES
  const [hasVariacaoGrade, setHasVariacaoGrade] = useState(false);
  const [itemsAbaGrade, setItemsAbaGrade] = useState<any[]>([]);
  const [produtoGradeDivisao, setProdutoGradeDivisao] = useState<any[]>([]);
  const [divisoesGradesLancadas, setDivisoesGradesLancadas] = useState<any[]>(
    [],
  );
  const [responseBuscaGrades, setResponseBuscaGrades] = useState<any[]>([]);
  // ====== IBS / CBS
  const [rowsIBS, setRowsIBS] = useState<any[]>([]);
  const [codIbsCbsRetriever, setCodIbsCbsRetriever] = useState<number | null>(
    null,
  );
  // ===== INSUMOS / DERIVADOS
  const [openModalDerivado, setOpenModalDerivado] = useState<boolean>(false);
  const [isEditingDerivado, setIsEditingDerivado] = useState<boolean>(false);
  const [loadingTableDerivado, setLoadingTableDerivado] =
    useState<boolean>(false);
  const [rowsDerivado, setRowsDerivado] = useState<IProdutoDerivado[]>([]);
  const [selectDerivado, setSelectDerivado] = useState<boolean>(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const masterDetailDefault = [
    {
      obj_name: 'produtos-derivados',
      pk_fields: ['cod_seq_produto_derivado'],
      itens: {
        insert: [],
        update: [],
        delete: [],
      },
    },
  ];
  const [masterDetail, setMasterDetail] =
    useState<MasterDetailProps[]>(masterDetailDefault);
  // ==== FLAGS
  const [flags, setFlags] = useState<FlagsState>(initialFlags);

  const { idContabeis, tipoItem } = useProdutoQueries();

  const {
    handleSubmit,
    register,
    control,
    reset,
    getValues,
    setValue,
    formState,
    setError,
    clearErrors,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    reValidateMode: 'onSubmit',
  });

  // form Derivado
  const {
    handleSubmit: handleSubmitDerivado,
    register: registerDerivado,
    control: controlDerivado,
    reset: resetDerivado,
    getValues: getValuesDerivado,
    setValue: setValueDerivado,
    formState: formStateDerivado,
    setError: setErrorDerivado,
    clearErrors: clearErrorsDerivado,
    watch: watchDerivado,
  } = useForm({
    resolver: yupResolver(schemaDerivado),
    reValidateMode: 'onChange',
  });

  useEffect(() => {
    if (Array.isArray(lojas)) {
      const lojaSort = lojas.sort((a: any, b: any) => {
        return a === selectedLoja ? -1 : b === selectedLoja ? 1 : 0;
      });
      const mLoja = lojaSort[0];
      if (mLoja) {
        if (mLoja !== mainLoja.cod_loja) {
          api.get(`/lojas/${mLoja}`).then((res) => {
            const { data } = res.data;
            setMainLoja({
              des_uf: data.des_uf,
              cod_loja: data.cod_loja,
              des_fantasia: data.des_fantasia,
              des_cidade: data.des_cidade,
              cst_pis_cof_ent_aliq_zero: data.cst_pis_cof_ent_aliq_zero,
              cst_pis_cof_ent_monof: data.cst_pis_cof_ent_monof,
              cst_pis_cof_ent_subst: data.cst_pis_cof_ent_subst,
              cst_pis_cof_ent_imune: data.cst_pis_cof_ent_imune,
              cst_pis_cof_ent_susp: data.cst_pis_cof_ent_susp,
              cst_pis_cof_entrada: data.cst_pis_cof_entrada,
              cst_pis_cof_saida_aliq_zero: data.cst_pis_cof_saida_aliq_zero,
              cst_pis_cof_saida_monof: data.cst_pis_cof_saida_monof,
              cst_pis_cof_saida_subst: data.cst_pis_cof_saida_subst,
              cst_pis_cof_saida_imune: data.cst_pis_cof_saida_imune,
              cst_pis_cof_saida_susp: data.cst_pis_cof_saida_susp,
              cst_pis_cof_saida: data.cst_pis_cof_saida,
            });
          });
        }
      }
    } else if (lojas) {
      api.get(`/lojas/${lojas}`).then((res) => {
        const { data } = res.data;
        setMainLoja({
          des_uf: data.des_uf,
          cod_loja: data.cod_loja,
          des_fantasia: data.des_fantasia,
          des_cidade: data.des_cidade,
          cst_pis_cof_ent_aliq_zero: data.cst_pis_cof_ent_aliq_zero,
          cst_pis_cof_ent_monof: data.cst_pis_cof_ent_monof,
          cst_pis_cof_ent_subst: data.cst_pis_cof_ent_subst,
          cst_pis_cof_ent_imune: data.cst_pis_cof_ent_imune,
          cst_pis_cof_ent_susp: data.cst_pis_cof_ent_susp,
          cst_pis_cof_entrada: data.cst_pis_cof_entrada,
          cst_pis_cof_saida_aliq_zero: data.cst_pis_cof_saida_aliq_zero,
          cst_pis_cof_saida_monof: data.cst_pis_cof_saida_monof,
          cst_pis_cof_saida_subst: data.cst_pis_cof_saida_subst,
          cst_pis_cof_saida_imune: data.cst_pis_cof_saida_imune,
          cst_pis_cof_saida_susp: data.cst_pis_cof_saida_susp,
          cst_pis_cof_saida: data.cst_pis_cof_saida,
        });
      });
    }
  }, [lojas]);

  const handleSetFocus = useCallback((campo: string) => {
    const input =
      document.getElementById(campo) ||
      document.querySelector<HTMLElement>(`[name="${campo}"]`);

    if (input) {
      setTimeout(() => {
        input.focus();
        input.click();
      }, 50);
    }
  }, []);

  const handleDivisoesGradesLancadas = useCallback((divisoes: any[]) => {
    setDivisoesGradesLancadas(divisoes);
  }, []);

  const handleResponseBuscaGrades = useCallback((resp: any[]) => {
    setResponseBuscaGrades(resp);
  }, []);

  // Controle das flags
  const ChangeFlags = useCallback((payload: FlagsUpdater) => {
    setFlags((prev) => {
      const newValues = typeof payload === 'function' ? payload(prev) : payload;

      return {
        ...prev,
        ...newValues,
      };
    });
  }, []);

  const handleItemsAbaGrade = useCallback((itemsGrade: any[]) => {
    setItemsAbaGrade(itemsGrade);
  }, []);
  const handleProdutoGradeDivisao = useCallback((produtoGrade: any[]) => {
    setProdutoGradeDivisao(produtoGrade);
  }, []);

  const handleHasVariacaoGrade = useCallback((has: boolean) => {
    setHasVariacaoGrade(has);
  }, []);

  function handleSelectedLoja(codLoja: number) {
    setSelectedLoja(codLoja);
  }

  const handleChangeSelectDerivado = useCallback((val: boolean) => {
    setSelectDerivado(val);
  }, []);

  const handleLojas = useCallback((value: number | number[]) => {
    setLojas(value);
  }, []);

  const handleClearProdutoFornecedor = useCallback(() => {
    setValue('busca_parceiro', {
      label: '',
      value: undefined,
    });

    setValue('des_embalagem', { value: '', label: '' });

    clearErrors('busca_parceiro');
    ChangeFlags({
      flg_fabricante: false,
    });
    setResetSimilar(false);
    setSelectedCodFornecedor(undefined);
  }, [setValue, clearErrors, ChangeFlags]);

  const resetProdutoForm = useCallback(() => {
    const cod_produto = getValues('cod_produto');
    resetDerivado({
      des_produto: '',
      cod_departamento: { label: undefined, value: undefined },
      cod_tipo_ajuste: { label: undefined, value: undefined },
    });
    reset(formProdutoBlankCompleto);
    setValue('cod_produto', cod_produto);

    // Estados que não pertencem ao form:
    setFlags(initialFlags);
    setHasVariacaoGrade(false);
    setSelectDerivado(false);
    setNcmIsFromTheProduct(true);
    setSelectedCodFornecedor(undefined);
    setRowsDerivado([]);
    setItemsAbaGrade([]);
    setProdutoGradeDivisao([]);
    setDivisoesGradesLancadas([]);
    setRowsIBS([]);
    setAssociadosPai([]);
    setAssociadosFilho([]);
    setMasterDetail(JSON.parse(JSON.stringify(masterDetailDefault)));
    setTipoGtin(13);
    setFormGtin(formGtinBlank);
    setFormProduto((prevState) => ({
      ...prevState,
      Gtins: {
        gtins: [],
        isInvalid: false,
        isRequired: false,
      },
    }));
  }, [masterDetailDefault, getValues, reset, resetDerivado, setValue]);

  const handleClearForms = useCallback(() => {
    setTabGeral('icms');
    setTab('geral');
    resetProdutoForm();
  }, [resetProdutoForm]);

  const handleTipoItemAndIdCtb = () => {
    const codDepartamento: any = getValues('cod_departamento');
    if (codDepartamento) {
      if (tipoItem.data.length > 0) {
        setValue(
          'cod_tipo_item',
          tipoItem.data.find(
            (item: any) => item.value === codDepartamento.cod_tipo_item,
          ),
        );
      }

      if (idContabeis.data.length > 0) {
        const codIdCtbSelected = idContabeis.data.find(
          (item: any) => item.value === codDepartamento.cod_id_ctb,
        );

        setValue('cod_id_ctb', codIdCtbSelected || { value: null, label: '' });
      }
    }
  };

  const handleResetForms = useCallback(() => {
    ChangeFlags({
      flg_fabricante: false,
    });

    setSelectedCodFornecedor(undefined);
    setValue('fornecedores', []);
  }, [setValue, ChangeFlags]);

  const handleSimilar = useCallback(async () => {
    const cod_similar = getValues('cod_similar');
    if (cod_similar.value) {
      await MySwal.fire({
        title: 'Confirmação',
        text: 'Produto a ser duplicado possui o campo similar relacionado. Deseja também duplicá-lo?',
        showCancelButton: true,
        confirmButtonColor: '#07289e',
        cancelButtonColor: '#ff7b7b',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (!result.isConfirmed) {
          setValue('cod_similar', {
            label: 'Nenhum Similar Selecionado',
            value: undefined,
          });
          setResetSimilar(true);
        }
      });
    }
  }, [MySwal, getValues, setValue]);

  async function handleDuplicateForm() {
    setFormProduto({
      ...formProduto,
      cod_gtin_principal: formProdutoBlank.cod_gtin_principal,
      Gtins: formProdutoBlank.Gtins,
    });

    const cod_similar = getValues('cod_similar');
    if (
      watch('fornecedores') !== undefined &&
      watch('fornecedores').length > 0
    ) {
      await MySwal.fire({
        title: 'Confirmação',
        text: 'Produto a ser duplicado possui fornecedores relacionados. Deseja também duplicá-los?',
        showCancelButton: true,
        confirmButtonColor: '#07289e',
        cancelButtonColor: '#ff7b7b',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then(async (result) => {
        if (!result.isConfirmed) handleResetForms();
        else {
          await delay(200);
          handleClearProdutoFornecedor();
        }
      });
    } else handleResetForms();

    setValue('embalagens', formProdutoBlank.Embalagens);
    setValue('cod_similar', cod_similar);
    setTimeout(handleSimilar, 500);

    if (hasVariacaoGrade && itemsAbaGrade.length > 0) {
      await MySwal.fire({
        title: 'Produto possui grade. NÃO será duplicada!',
        text: 'Será necessário montar a grade do novo produto.',
        icon: 'info',
      });
      handleItemsAbaGrade([]);
      handleDivisoesGradesLancadas([]);
      handleHasVariacaoGrade(true);
    }
  }

  function changeFormProduto(value: FormProduto) {
    setFormProduto(value);
  }
  const changeFormProdutoLoja = useCallback((value: FormProdutoLoja) => {
    setFormProdutoLoja(value);
  }, []);

  function toggleIsUpdate(value: boolean) {
    setIsUpdate(value);
  }

  function toggleIsShowSearch(value: boolean) {
    setIsShowSearch(value);
  }

  const handleChangeInput = (valores: { entrada: string; saida: string }) => {
    const entradaFiltrada = tipoPisCofinsEntrada.find((item: Select) => {
      return Number(item.value) === Number(valores.entrada);
    });
    const saidaFiltrada = tipoPisCofinsSaida.find((item: Select) => {
      return Number(item.value) === Number(valores.saida);
    });
    setValue('cst_entrada', entradaFiltrada);
    setValue('cst_saida', saidaFiltrada);
  };

  const mapeamentoValoresCst: MapeamentoValores = {
    '-1': {
      entrada: loja.cst_pis_cof_entrada,
      saida: loja.cst_pis_cof_saida,
    },
    '0': {
      entrada: loja.cst_pis_cof_ent_aliq_zero,
      saida: loja.cst_pis_cof_saida_aliq_zero,
    },
    '1': {
      entrada: loja.cst_pis_cof_ent_monof,
      saida: loja.cst_pis_cof_saida_monof,
    },
    '2': {
      entrada: loja.cst_pis_cof_ent_subst,
      saida: loja.cst_pis_cof_saida_subst,
    },
    '3': {
      entrada: loja.cst_pis_cof_ent_imune,
      saida: loja.cst_pis_cof_saida_imune,
    },
    '4': {
      entrada: loja.cst_pis_cof_ent_susp,
      saida: loja.cst_pis_cof_saida_susp,
    },
    '5': {
      entrada: loja.cst_pis_cof_ent_monof,
      saida: loja.cst_pis_cof_saida,
    },
  };

  const handleChangeValoresCst = (
    tipo: keyof MapeamentoValores,
  ): { entrada: string; saida: string } | null => {
    if (tipo in mapeamentoValoresCst) {
      const valores = mapeamentoValoresCst[tipo];
      handleChangeInput(valores);
    }
    return null;
  };

  const desabilitarBuscaModal = () => {
    const { tipo_nao_pis_cofins } = getValues();
    if (!flags.flg_nao_pis_cofins || tipo_nao_pis_cofins === undefined) {
      return true;
    }
    if (Number(tipo_nao_pis_cofins?.value) === 5) {
      return true;
    }
    return false;
  };

  const handleChangeEnabledModal = () => {
    setEnableModalSped((prev: boolean) => {
      return !prev;
    });
  };

  async function handleTipoIPI(value: number | string) {
    if (value === -1) setIpiHabilitar(true);
    else setIpiHabilitar(false);
  }

  const handleChangeRowsIBS = useCallback(
    async (cod_ibs_cbs: number | null) => {
      setCodIbsCbsRetriever(cod_ibs_cbs);

      if (cod_ibs_cbs === null || !cod_ibs_cbs) {
        setRowsIBS([]);
        return;
      }

      const { data } = await api.get('/classificacao-ibs-cbs/buscaUF', {
        params: { cod_ibs_cbs },
      });
      setRowsIBS(data.data);
    },
    [],
  );

  const handleGetInsumos = useCallback(
    async (cod_produto: string, cod_loja: number) => {
      setLoadingTableDerivado(true);
      try {
        const res = await api.get(
          `/produto/get-insumos/${cod_produto}/${cod_loja}`,
        );
        const { data, success } = res.data;
        if (success) {
          const insertValues = data.map((i: any) => {
            const uuid = nanoid();
            return {
              uuid,
              ...i,
              des_unidade: {
                value: i.des_unidade_venda,
                label: i.des_unidade_venda,
              },
              cod_tipo_ajuste: {
                label: `${i.cod_tipo_ajuste} - ${i.des_operacao} ${i.des_ajuste}`,
                value: i.cod_tipo_ajuste,
              },
              cod_departamento: {
                value: i.cod_departamento,
                label: i.des_departamento,
              },
            };
          });

          if (!insertValues || insertValues.length <= 0) return;

          addUpdate(
            'produtos-derivados',
            insertValues,
            masterDetail,
            setMasterDetail,
          );
          setRowsDerivado(insertValues);
        }
      } catch (error: any) {
        toast.warn(`Erro ao adicionar produtos derivados: ${error.message}`);
      } finally {
        setLoadingTableDerivado(false);
      }
    },
    [masterDetail],
  );

  const handleIsEditingDerivado = useCallback((isEditing: boolean) => {
    setIsEditingDerivado(isEditing);
  }, []);

  const verifyIfIsDerivado = useCallback(async (): Promise<boolean> => {
    if (!isUpdate) return false;

    const cod_produto = watch('cod_produto');
    const res = await api.get(`/produto-derivado/${cod_produto}`);
    const { data } = res.data;

    if (data > 0) {
      toast.warn(
        'Produto é derivado de outro, não pode-se criar um derivado dele',
      );
      return true;
    }

    return false;
  }, [isUpdate, watch]);

  const handleOpenModalDerivado = useCallback(
    async (open: boolean) => {
      const isDerivado = await verifyIfIsDerivado();
      if (isDerivado) return;
      if (open === false) {
        handleIsEditingDerivado(false);
      }

      setTimeout(() => {
        const input = document.getElementById('desProdDerivado');
        input?.focus();
      }, 150);

      setOpenModalDerivado(open);
    },
    [handleIsEditingDerivado, verifyIfIsDerivado],
  );

  const handleChangeAssoc = useCallback(
    (value: number) => {
      if (value === 2) {
        setValue('per_desc_assoc', '');
      }
      setValue('tipo_associado', value);

      setValue('per_desc_assoc', '');
      setValue('per_acresc_assoc', '');
      setValue('cod_associado', { value: undefined, label: '' });
      handleSetFocus('cod_associado');
    },
    [handleSetFocus, setValue],
  );

  const value: ProdutoContextData = useMemo(
    () => ({
      formProduto,
      changeFormProduto,
      formProdutoLoja,
      changeFormProdutoLoja,
      isUpdate,
      handleClearForms,
      toggleIsUpdate,
      isShowSearch,
      toggleIsShowSearch,
      handleSelectedLoja,
      selectedLoja,
      lojas,
      handleLojas,
      handleDuplicateForm,
      mainLoja,
      tipoGtin,
      setTipoGtin,
      formGtin,
      setFormGtin,
      selectedCodFornecedor,
      setSelectedCodFornecedor,
      register,
      control,
      reset,
      getValues,
      setValue,
      formState,
      setError,
      clearErrors,
      watch,
      handleSubmit,
      ncmIsFromTheProduct,
      setNcmIsFromTheProduct,
      handleChangeValoresCst,
      handleSetFocus,
      desabilitarBuscaModal,
      enableModalSped,
      setEnableModalSped,
      handleChangeEnabledModal,
      handleTipoIPI,
      ipiHabilitar,
      setIpiHabilitar,
      tabGeral,
      setTabGeral,
      tab,
      setTab,
      produtoFornecedores,
      setProdutoFornecedores,
      formProdFornUN,
      setFormProdFornUN,
      formProdutoFornecedor,
      setFormProdutoFornecedor,
      handleClearProdutoFornecedor,

      associadosPai,
      setAssociadosPai,
      associadosFilho,
      setAssociadosFilho,

      handleTipoItemAndIdCtb,
      resetSimilar,
      setResetSimilar,

      hasVariacaoGrade,
      handleHasVariacaoGrade,

      itemsAbaGrade,
      handleItemsAbaGrade,
      handleProdutoGradeDivisao,
      produtoGradeDivisao,
      divisoesGradesLancadas,
      handleDivisoesGradesLancadas,
      responseBuscaGrades,
      handleResponseBuscaGrades,

      rowsIBS,
      handleChangeRowsIBS,
      codIbsCbsRetriever,

      openModalDerivado,
      handleOpenModalDerivado,
      isEditingDerivado,
      handleIsEditingDerivado,
      handleGetInsumos,
      loadingTableDerivado,
      setLoadingTableDerivado,
      rowsDerivado,
      setRowsDerivado,
      selectDerivado,
      handleChangeSelectDerivado,
      verifyIfIsDerivado,

      masterDetail,
      setMasterDetail,

      handleSubmitDerivado,
      registerDerivado,
      controlDerivado,
      resetDerivado,
      getValuesDerivado,
      setValueDerivado,
      formStateDerivado,
      setErrorDerivado,
      clearErrorsDerivado,
      watchDerivado,

      handleChangeAssoc,
      flags,
      ChangeFlags,
    }),
    [
      formProduto,
      formProdutoLoja,
      isUpdate,
      isShowSearch,
      selectedLoja,
      lojas,
      mainLoja,
      tipoGtin,
      formGtin,
      selectedCodFornecedor,
      formState,
      ncmIsFromTheProduct,
      enableModalSped,
      ipiHabilitar,
      tabGeral,
      tab,
      produtoFornecedores,
      formProdFornUN,
      formProdutoFornecedor,
      associadosPai,
      associadosFilho,
      resetSimilar,
      hasVariacaoGrade,
      itemsAbaGrade,
      produtoGradeDivisao,
      divisoesGradesLancadas,
      responseBuscaGrades,
      rowsIBS,
      codIbsCbsRetriever,
      openModalDerivado,
      isEditingDerivado,
      loadingTableDerivado,
      rowsDerivado,
      selectDerivado,
      masterDetail,
      flags,
    ],
  );

  return (
    <ProdutoContext.Provider value={value}>{children}</ProdutoContext.Provider>
  );
}
